/** Пустой group_ids = все группы клуба. */

export function normalizeGroupIds(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw.map(String).filter(Boolean);
  return [];
}

export function planGroupIds(plan) {
  return normalizeGroupIds(plan?.group_ids);
}

export function membershipGroupIds(membership) {
  if (!membership) return [];
  if (membership.group_ids != null) {
    return normalizeGroupIds(membership.group_ids);
  }
  return planGroupIds(membership?.plan);
}

export function isClubWide(groupIds) {
  return !groupIds || groupIds.length === 0;
}

export function groupsOverlap(a, b) {
  const ga = normalizeGroupIds(a);
  const gb = normalizeGroupIds(b);
  if (isClubWide(ga) || isClubWide(gb)) return true;
  const setB = new Set(gb);
  return ga.some((id) => setB.has(String(id)));
}

export function membershipScopeLabel(groupIds, groupNameById = {}) {
  const ids = normalizeGroupIds(groupIds);
  if (isClubWide(ids)) return "Все группы";
  if (ids.length === 1) return groupNameById[ids[0]] || "1 группа";
  return ids.map((id) => groupNameById[id] || "группа").join(", ");
}

export function planAppliesToClientGroups(plan, clientGroupIds) {
  const planIds = planGroupIds(plan);
  if (isClubWide(planIds)) return true;
  const clientSet = new Set(normalizeGroupIds(clientGroupIds).map(String));
  if (!clientSet.size) return isClubWide(planIds);
  return planIds.some((id) => clientSet.has(String(id)));
}
